import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import RefrigerationEquipLogForm from "./RefrigerationEquipLogForm";

const EditRefrigerationEquipLog = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);

    post(ApiURL.ods_record_get, fd).then((res) => {
      if (res?.status == true) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  const handleSuccess = () => {
    navigate("/refrigeration-equip-log");
  };

  return (
    <>
      <h2>Edit Refrigeration Equip Log</h2>
      <RefrigerationEquipLogForm
        mode="edit"
        odsId={id}
        recordId={details?.record_id}
        records={[details]}
        onSaveSuccess={handleSuccess}
      />
    </>
  );
};

export default EditRefrigerationEquipLog;
